"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.patterns = exports.messages = exports.default = void 0;

var _get2 = _interopRequireDefault(require("lodash/get"));

var _filter2 = _interopRequireDefault(require("lodash/filter"));

var _isBoolean2 = _interopRequireDefault(require("lodash/isBoolean"));

var _isFunction2 = _interopRequireDefault(require("lodash/isFunction"));

var _isArray2 = _interopRequireDefault(require("lodash/isArray"));

var _includes2 = _interopRequireDefault(require("lodash/includes"));

var _isUndefined2 = _interopRequireDefault(require("lodash/isUndefined"));

var _isNull2 = _interopRequireDefault(require("lodash/isNull"));

var _isString2 = _interopRequireDefault(require("lodash/isString"));

var _isNumber2 = _interopRequireDefault(require("lodash/isNumber"));

// options for future exensibility
var options = {}; // Patterns

var patterns = {
  // Pattern taken from passwordReset.scala.html
  password: /^(?!.*(.)\1{2})([A-Za-z0-9 !@#$%^&*()\\\/\-_=+{};:,<.>~'"`\[\]?]{8,120})$/,
  dateISO: /^\d{4}[/-](0?[1-9]|1[012])[/-](0?[1-9]|[12][0-9]|3[01])$/,
  date: /^(\d{4}[-/]\d\d?[-/]\d\d?)|(\d\d?[-/]\d\d?[-/]\d{4})$/,
  textArea: /^[A-Za-z0-9\s.,!?;:'"()#$%&*@+/=^_{|}~-]*$/,
  phoneNumber: /^[2-9][0-9]{9}$/,
  hours: /^(0?[1-9]|1[012])(:[0-5]\d)\s[AP]M$/i,
  // A simple title: letters, numbers, or (. , ; : ' # _ -), used licenses, titles, etc
  title: /^[A-Za-z0-9\s.,;:'#_-]*$/,
  city: /^[A-Za-z\s.,'-]*$/,
  creditCard: new RegExp('^(?:' + '4\\d{12}(?:\\d{3})?' + // Visa
  '|5[1-5]\\d{14}' + // MasterCard
  '|3[47]\\d{13}' + // American Express
  '|3(?:0[0-5]|[68]\\d)\\d{11}' + // Diners Club
  '|6(?:011|5\\d{2})\\d{12}' + // Discover
  '|(?:2131|1800|35\\d{3})\\d{11}' + // JCB
  ')$'),
  creditCardSecurityCode: /^\d{3,4}$/,
  // Same as title with the addition of allowing @, used for account holder, payee name, business name, etc
  businessName: /^[A-Za-z0-9@\s.,!?;:'"()#$%&*+/=^_{|}~-]*$/,
  // Matches any digit(s) (i.e. 0-9)
  digits: /^\d+$/,
  // Matched any number (e.g. 100.000)
  number: /^-?(?:\d+|\d{1,3}(?:,\d{3})+)(?:\.\d+)?$/,
  // Matches a valid email address (e.g. mail@example.com)
  email: // eslint-disable-next-line no-control-regex
  /^((([a-z]|\d|[!#$%&'*+\-/=?^_`{|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#$%&'*+\-/=?^_`{|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i,
  postalCode: /^\d{5}(-\d{4})?$/,
  // Matches any valid url (e.g. http://www.example.com)
  url: /^(https?|ftp):\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!$&'()*+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!$&'()*+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!$&'()*+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!$&'()*+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!$&'()*+,;=]|:|@)|\/|\?)*)?$/i,
  // Matches any valid https-based url (e.g. https://www.example.com/webhook/1234)
  urlHttps: /^https:\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!$&'()*+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!$&'()*+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!$&'()*+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!$&'()*+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!$&'()*+,;=]|:|@)|\/|\?)*)?$/i
}; // Date Patterns that only validate that it consists of numbers and delimiters: see checkDate() for usage

exports.patterns = patterns;
var datePatterns = {
  'MM/dd/yyyy': /^(\d?\d)\/(\d?\d)\/(\d{4})$/,
  'MM-dd-yyyy': /^(\d?\d)-(\d?\d)-(\d{4})$/,
  'MM.dd.yyyy': /^(\d?\d)\.(\d?\d)\.(\d{4})$/,
  MMddyyyy: /^(\d\d)(\d\d)(\d{4})$/,
  'dd/MM/yyyy': /^(\d?\d)\/(\d?\d)\/(\d{4})$/,
  'dd-MM-yyyy': /^(\d?\d)-(\d?\d)-(\d{4})$/,
  'dd.MM.yyyy': /^(\d?\d)\.(\d?\d)\.(\d{4})$/,
  ddMMyyyy: /^(\d\d)(\d\d)(\d{4})$/
}; // Named groups to parse the date uniformly. See checkDate() for usage

var datePatternNamedGroups = {
  'MM/dd/yyyy': {
    day: 2,
    month: 1,
    year: 3
  },
  'MM-dd-yyyy': {
    day: 2,
    month: 1,
    year: 3
  },
  'MM.dd.yyyy': {
    day: 2,
    month: 1,
    year: 3
  },
  MMddyyyy: {
    day: 2,
    month: 1,
    year: 3
  },
  'dd/MM/yyyy': {
    day: 1,
    month: 2,
    year: 3
  },
  'dd-MM-yyyy': {
    day: 1,
    month: 2,
    year: 3
  },
  'dd.MM.yyyy': {
    day: 1,
    month: 2,
    year: 3
  },
  ddMMyyyy: {
    day: 1,
    month: 2,
    year: 3
  }
}; // Error message for the build in validators.
// {x} gets swapped out with arguments from the validator.

var messages = {
  required: '{0} is required',
  acceptance: '{0} must be accepted',
  min: '{0} must be greater than or equal to {1}',
  max: '{0} must be less than or equal to {1}',
  range: '{0} must be between {1} and {2}',
  length: '{0} must be {1} characters',
  minLength: '{0} must be at least {1} characters',
  maxLength: '{0} cannot exceed {1} characters',
  rangeLength: '{0} must be between {1} and {2} characters',
  oneOf: '{0} must be one of: {1}',
  containsNoneOf: '{0} must not contain: {1}',
  equalTo: '{0} must be the same as {1}',
  pattern: 'Is this a valid {0}?',
  creditCard: 'Must be a valid credit card number',
  creditCardSecurityCode: 'Must be a 3 or 4 digit number',
  hours: 'Please enter a valid time: ##:## AM or PM',
  date: 'Must be a valid date',
  phoneNumber: 'Must enter a valid 10-digit phone number',
  password: "Must be at least 8 characters. No more than 2 consecutive repeated characters ('oo' works, but not 'ooo')",
  textArea: 'Please use only the following characters: letters, numbers and . , ! ? ; : \' " ( ) # @ $ % & * + - / = ^ _ { | } ~',
  title: "Please use only the following characters: letters, numbers and . , ; : ' # _ -",
  city: "Please use only the following characters: letters and . , ' -",
  businessName: 'Please use only the following characters: letters, numbers and . , ! ? ; : \' " ( ) # $ @ % & * + - / = ^ _ { | } ~',
  email: 'Must enter a valid email address',
  postalCode: 'Must enter a valid ZIP code'
}; // Label formatters are used to convert the attribute name to a more human friendly label when using the built in error messages.

exports.messages = messages;
var labelFormatters = {
  // Returns the attribute name with applying any formatting
  none: function none(attrName) {
    return attrName;
  },
  // Converts attributeName or attribute_name to Attribute name
  sentenceCase: function sentenceCase(attrName) {
    // If attrName contains a '.' get only text aftr the last '.'
    // Ex: 'User.firstName' => 'First name'
    var name = attrName.indexOf('.') > -1 ? attrName.split('.').pop() : attrName;
    return name.replace(/(?:^\w|[A-Z]|\b\w)/g, function (match, index) {
      return index === 0 ? match.toUpperCase() : ' ' + match.toLowerCase();
    }).replace('_', ' ');
  }
}; // Determines whether or not a value is a number

var isNumber = function isNumber(value) {
  return (0, _isNumber2.default)(value) || (0, _isString2.default)(value) && value.match(patterns.number);
}; // Determines whether or not not a value is empty


var hasValue = function hasValue(value) {
  return !((0, _isNull2.default)(value) || (0, _isUndefined2.default)(value) || (0, _isString2.default)(value) && value.trim() === '');
}; // Uses the configured label formatter to format the attribute name
// to make it more readable for the user


var formatLabel = function formatLabel(attrName, data) {
  return labelFormatters[(options || {}).labelFormatter || 'sentenceCase'](attrName, data);
};

var format = function format() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var text = args.shift(); // first argument is the "text", the rest are formatting args

  return text.replace(/\{(\d+)\}/g, function (match, number) {
    return !(0, _isUndefined2.default)(args[number]) ? args[number] : match;
  });
};

var checkDate = function checkDate(value, pattern) {
  // Find the pattern to match/test against
  var regexp = datePatterns[pattern];

  if (!regexp || !regexp.test(value)) {
    // Bad date format to begin with. Reject right away
    return false;
  } else {
    // Find the Named Groups so that we can extract day, month, year uniformly
    var regexGroups = datePatternNamedGroups[pattern];

    if (!regexGroups) {
      // No named group found for the pattern, is bad. Reject it.
      return false;
    }

    var groups = regexp.exec(value); // Extract Day, Month, and Year part from the value

    var year = parseInt(groups[regexGroups.year], 10);
    var month = parseInt(groups[regexGroups.month], 10);
    var day = parseInt(groups[regexGroups.day], 10); // Apply validations not part of the Regular expression

    if (day < 1 || day > 31) {
      // Bad dates for any month
      return false;
    } else if (month < 1 || month > 12) {
      // Bad months
      return false;
    } else if (month === 2 && day > 29) {
      // Bad date in any february
      return false;
    } else if (day > 30 && (0, _includes2.default)([4, 6, 9, 11], month)) {
      // Bad 31 in months of Apr, Jun, Sep, Nov
      return false;
    } else if (month === 2 && day === 29 && !(year % 400 === 0 || year % 100 !== 0 && year % 4 === 0)) {
      // Leap Day on a Non-Leap year, is bad
      return false;
    }
  } // Everything else is good


  return true;
};

var checkCreditCard = function checkCreditCard(value) {
  // http://jqueryvalidation.org/creditcard-method/
  // based on http://en.wikipedia.org/wiki/Luhn/
  // accept only spaces, digits and dashes
  if (/[^\d -]+/.test(value)) {
    return false;
  }

  var nCheck = 0;
  var nDigit = 0;
  var bEven = false;
  var n;
  var cDigit;
  var v = value.replace(/\D/g, ''); // Basing min and max length on
  // http://developer.ean.com/general_info/Valid_Credit_Card_Types

  if (v.length < 13 || v.length > 19) {
    return false;
  }

  if (!patterns.creditCard.test(v)) {
    return false;
  }

  for (n = v.length - 1; n >= 0; n--) {
    cDigit = v.charAt(n);
    nDigit = parseInt(cDigit, 10);

    if (bEven) {
      /* eslint "no-cond-assign": 0 */
      if ((nDigit *= 2) > 9) {
        nDigit -= 9;
      }
    }

    nCheck += nDigit;
    bEven = !bEven;
  }

  return nCheck % 10 === 0;
};

var validators = {
  // Function validator
  // Lets you implement a custom function used for validation
  fn: function fn(value, attr, _fn, model) {
    var func = _fn;

    if ((0, _isString2.default)(func)) {
      func = model[func];
    }

    return func.call(model, value, attr);
  },
  // Min Array Size validator
  minArray: function minArray(value, attr, _minArray, model) {
    if (!(0, _isArray2.default)(value) || value.length < _minArray) {
      return format(messages.min, formatLabel(attr, model), _minArray);
    }

    return undefined;
  },
  // Required validator
  // Validates if the attribute is required or not
  required: function required(value, attr, _required, model) {
    var isRequired = (0, _isFunction2.default)(_required) ? _required.call(model, value, attr) : _required;

    if (!isRequired && !hasValue(value)) {
      return false; // overrides all other validators
    }

    if (isRequired && !hasValue(value)) {
      return format(messages.required, formatLabel(attr, model));
    }

    return undefined;
  },
  // Acceptance validator
  // Validates that something has to be accepted, e.g. terms of use
  // `true` or 'true' are valid
  acceptance: function acceptance(value, attr, accept, model) {
    if (!accept) {
      return undefined;
    }

    if (value !== 'true' && (!(0, _isBoolean2.default)(value) || value === false)) {
      return format(messages.acceptance, formatLabel(attr, model));
    }

    return undefined;
  },
  // Min validator
  // Validates that the value has to be a number and equal to or greater than
  // the min value specified
  min: function min(value, attr, minValue, model) {
    if (!isNumber(value) || value < minValue) {
      return format(messages.min, formatLabel(attr, model), minValue);
    }

    return undefined;
  },
  // Max validator
  // Validates that the value has to be a number and equal to or less than
  // the max value specified
  max: function max(value, attr, maxValue, model) {
    if (!isNumber(value) || value > maxValue) {
      return format(messages.max, formatLabel(attr, model), maxValue);
    }

    return undefined;
  },
  // Range validator
  // Validates that the value has to be a number and equal to or between
  // the two numbers specified
  range: function range(value, attr, _range, model) {
    if (!isNumber(value) || value < _range[0] || value > _range[1]) {
      return format(messages.range, formatLabel(attr, model), _range[0], _range[1]);
    }

    return undefined;
  },
  // Length validator
  // Validates that the value has to be a string with length equal to
  // the length value specified
  length: function length(value, attr, _length, model) {
    if (!hasValue(value) || value.trim().length !== _length) {
      return format(messages.length, formatLabel(attr, model), _length);
    }

    return undefined;
  },
  // Min length validator
  // Validates that the value has to be a string with length equal to or greater than
  // the min length value specified
  minLength: function minLength(value, attr, _minLength, model) {
    if (!hasValue(value) || value.trim().length < _minLength) {
      return format(messages.minLength, formatLabel(attr, model), _minLength);
    }

    return undefined;
  },
  // Max length validator
  // Validates that the value has to be a string with length equal to or less than
  // the max length value specified
  maxLength: function maxLength(value, attr, _maxLength, model) {
    if (!hasValue(value) || value.trim().length > _maxLength) {
      return format(messages.maxLength, formatLabel(attr, model), _maxLength);
    }

    return undefined;
  },
  // Range length validator
  // Validates that the value has to be a string and equal to or between
  // the two numbers specified
  rangeLength: function rangeLength(value, attr, range, model) {
    if (!hasValue(value) || value.trim().length < range[0] || value.trim().length > range[1]) {
      return format(messages.rangeLength, formatLabel(attr, model), range[0], range[1]);
    }

    return undefined;
  },
  // One of validator
  // Validates that the value has to be equal to one of the elements in
  // the specified array. Case sensitive matching
  oneOf: function oneOf(value, attr, values, model) {
    if (!(0, _includes2.default)(values, value)) {
      return format(messages.oneOf, formatLabel(attr, model), values.join(', '));
    }

    return undefined;
  },
  // Contains none of validator
  // Validates that the value does not contain, as a substring, any of the
  // elements in the specified array. Case sensitive matching
  containsNoneOf: function containsNoneOf(value, attr, values, model) {
    var found = (0, _filter2.default)(values, function (s) {
      return value.includes(s);
    });

    if (found.length > 0) {
      return format(messages.containsNoneOf, formatLabel(attr, model), found.join(', '));
    }

    return undefined;
  },
  // Equal to validator
  // Validates that the value has to be equal to the value of the attribute
  // with the name specified
  equalTo: function equalTo(value, attr, _equalTo, model) {
    if (value !== (0, _get2.default)(model, _equalTo)) {
      return format(messages.equalTo, formatLabel(attr, model), formatLabel(_equalTo, model));
    }

    return undefined;
  },
  // Pattern validator
  // Validates that the value has to match the pattern specified.
  // Can be a regular expression or the name of one of the built in patterns
  pattern: function pattern(value, attr, _pattern, model) {
    if (!hasValue(value) || !value.toString().match(patterns[_pattern] || _pattern)) {
      return format(messages.pattern, formatLabel(attr, model), _pattern);
    }

    return undefined;
  },
  date: function date(value, attr, customValue, model) {
    if (!customValue || !value) {
      return undefined;
    }

    var isValid = customValue === true && patterns.date.test(value) || customValue !== true && checkDate(value, customValue);

    if (!isValid) {
      return format(messages.date, formatLabel(attr, model));
    }

    return undefined;
  },
  textArea: function textArea(value, attr, customValue, model) {
    if (!customValue) {
      return undefined;
    }

    var isValid = patterns.textArea.test(value);

    if (!isValid) {
      return format(messages.textArea, formatLabel(attr, model));
    }

    return undefined;
  },
  password: function password(value, attr, customValue, model) {
    if (!customValue) {
      return undefined;
    }

    var isValid = patterns.password.test(value);

    if (!isValid) {
      return format(messages.password, formatLabel(attr, model));
    }

    return undefined;
  },
  phoneNumber: function phoneNumber(value, attr, customValue, model) {
    if (!customValue) {
      return undefined;
    }

    var isValid = patterns.phoneNumber.test(value);

    if (!isValid) {
      return format(messages.phoneNumber, formatLabel(attr, model));
    }

    return undefined;
  },
  title: function title(value, attr, customValue, model) {
    if (!customValue) {
      return undefined;
    }

    var isValid = patterns.title.test(value);

    if (!isValid) {
      return format(messages.title, formatLabel(attr, model));
    }

    return undefined;
  },
  city: function city(value, attr, customValue, model) {
    if (!customValue) {
      return undefined;
    }

    var isValid = patterns.city.test(value);

    if (!isValid) {
      return format(messages.city, formatLabel(attr, model));
    }

    return undefined;
  },
  businessName: function businessName(value, attr, customValue, model) {
    if (!customValue) {
      return undefined;
    }

    var isValid = patterns.businessName.test(value);

    if (!isValid) {
      return format(messages.businessName, formatLabel(attr, model));
    }

    return undefined;
  },
  creditCard: function creditCard(value, attr, customValue, model) {
    if (!customValue || !value) {
      return undefined;
    }

    if ((value && 0) <= value.length && !checkCreditCard(value)) {
      return format(messages.creditCard, formatLabel(attr, model));
    }

    return undefined;
  },
  creditCardSecurityCode: function creditCardSecurityCode(value, attr, customValue, model) {
    if (!customValue) {
      return undefined;
    }

    var isValid = patterns.creditCardSecurityCode.test(value);

    if (!isValid) {
      return format(messages.creditCardSecurityCode, formatLabel(attr, model));
    }

    return undefined;
  },
  validateHours: function validateHours(value, attr, customValue, model) {
    if (!customValue) {
      return undefined;
    }

    var isValid = patterns.hours.test(value);

    if (!isValid) {
      return format(messages.hours, formatLabel(attr, model));
    }

    return undefined;
  },
  email: function email(value, attr, customValue, model) {
    if (!customValue) {
      return undefined;
    }

    var isValid = patterns.email.test(value);

    if (!isValid) {
      return format(messages.email, formatLabel(attr, model));
    }

    return undefined;
  },
  postalCode: function postalCode(value, attr, customValue, model) {
    if (!customValue) {
      return undefined;
    }

    var isValid = patterns.postalCode.test(value);

    if (!isValid) {
      return format(messages.postalCode, formatLabel(attr, model));
    }

    return undefined;
  }
};
var _default = validators;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-app-platform/lib/common/validation/validators.js
// module id = 3160
// module chunks = 25